import React, { useEffect, useState } from 'react'
import { isTokenExpired } from '../utils/Apis/axios-instance'

const PrivateRoutes = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token && !isTokenExpired(token)) {
      setIsAuthenticated(true)
    } else {
      localStorage.removeItem('token')
      localStorage.removeItem('id')
      setIsAuthenticated(false)
      window.location.href = '/login'
    }
  }, [])
  return <>{isAuthenticated ? children : null}</>
}

export default PrivateRoutes
